/**
 * Query key factory for the Matomo web analytics report. Keeps cache keys consistent across the
 * aggregated table and the filter-drawer facet counts so they invalidate together.
 */
export const webAnalyticsQueryKeys = {
  all: ["webAnalytics"] as const,

  /** GET /api/v2/WebAnalytics/Aggregated */
  aggregated: (params: Record<string, unknown>) =>
    [...webAnalyticsQueryKeys.all, "aggregated", params] as const,

  /** GET /api/v2/WebAnalytics/FilterCounts */
  filterCounts: (params: Record<string, unknown>) =>
    [...webAnalyticsQueryKeys.all, "filterCounts", params] as const,

  /** GET /api/v2/WebAnalytics/Metrics/Aggregated */
  metrics: (params: Record<string, unknown>) =>
    [...webAnalyticsQueryKeys.all, "metrics", params] as const,
};
